import styled from 'styled-components';

const QnABox = styled.div`
  padding: 23px;
  margin: 12px 0;
  border: 1px solid #bcbcbc;
`;

export default QnABox;
